var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"6","height":"6","viewBox":"0 0 6 6"}},[_c('circle',{attrs:{"id":"bullet","cx":"3","cy":"3","r":"3","fill":"rgba(118,131,145,0.2)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }